/*
 * jQuery doTimeout: Like setTimeout, but better! - v1.0 - 3/3/2010
 * http://benalman.com/projects/jquery-dotimeout-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function($){var a={},c="doTimeout",d=Array.prototype.slice;$[c]=function(){return b.apply(window,[0].concat(d.call(arguments)))};$.fn[c]=function(){var f=d.call(arguments),e=b.apply(this,[c+f[0]].concat(f));return typeof f[0]==="number"||typeof f[1]==="number"?this:e};function b(l){var m=this,h,k={},g=l?$.fn:$,n=arguments,i=4,f=n[1],j=n[2],p=n[3];if(typeof f!=="string"){i--;f=l=0;j=n[1];p=n[2]}if(l){h=m.eq(0);h.data(l,k=h.data(l)||{})}else{if(f){k=a[f]||(a[f]={})}}k.id&&clearTimeout(k.id);delete k.id;function e(){if(l){h.removeData(l)}else{if(f){delete a[f]}}}function o(){k.id=setTimeout(function(){k.fn()},j)}if(p){k.fn=function(q){if(typeof p==="string"){p=g[p]}p.apply(m,d.call(n,i))===true&&!q?o():e()};o()}else{if(k.fn){j===undefined?e():k.fn(j===false);return true}else{e()}}}})(jQuery);

var VEHICLE_COOKIE = 'vehicle-filter-tag';

function cleanArray(actual) {
  var newArray = new Array();

  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }

  return newArray;
}

function getfilterChain() {
  var truck = jQuery('[data-current-vehicle-tag]').data('current-vehicle-tag') ? jQuery('[data-current-vehicle-tag]').data('current-vehicle-tag').replace(':','-').toLowerCase() : '';
  var filters = getfilterChainNoTruck();

  if (truck.length > 0 && filters.length > 0)
    return '/' + truck + '+' + filters;
  if (truck.length > 0)
    return '/' + truck;
  if (filters.length > 0)
    return '/' + filters;
  return '';
}

function getfilterChainNoTruck() {
  var checkedFilters = [];

  jQuery('#filter_list input:checked').each(function() {
    var path = jQuery(this).attr('id').split('_desktop');

    if (!path[0].startsWith('compatibility-')) checkedFilters.push(path[0]);
  });

  return checkedFilters.join('+');
}

function reloadWithVehicle(baseUrl, categoryTag, vehicleTag) {
    if(categoryTag.length === 0) categoryTag = undefined;
    if(baseUrl.length === 0) baseUrl = '/collections/all';

  window.location.href = (baseUrl.replace('?view=grid', '').replace('?view=list', '') + '/' + cleanArray([categoryTag, vehicleTag]).join('+')).replace('collections/compatibility::', 'collections/compatibility-');
}

function removeLastChar (myUrl, char ){
    if (myUrl.substring(myUrl.length-1) == char){
      myUrl = myUrl.substring(0, myUrl.length-1);
    }
    return myUrl;
}

function appendFilter(url){
  var urlSplitted = url.split(document.domain);
  url = urlSplitted[0]+document.domain+urlSplitted[1].replace('//','/');

  url = url.replace('undefined','').replace('++','+').replace('?view=grid','').replace('?view=list','').replace('#','').replace('//+','/');

  window.location.href = url;
}

function countFilters(){
  var check_counter = jQuery('#modal_filters_list input:checkbox:checked').length;

  if (isNaN(check_counter)){
    check_counter = '';
    jQuery('#reset_filters_link').css('display','none');
    jQuery('#view-filters-toggle').css('display','inline');
  } else if (check_counter > 0) {
    jQuery('#view-filters-toggle').css('display','none');
    jQuery('#reset_filters_link').css('display','inline');
    check_counter = ' (' + check_counter + ')';
  } else {
    check_counter = '';
  }
  jQuery('#filter_counter').text('Filters' + check_counter);
}

function resetVehicleFilter(el){
  var appliedFilters =  jQuery('#filter_list input:checkbox:checked').length;
  if(appliedFilters >= 1){
    var currentUrl = el.attr('data-href');
    var newUrl = currentUrl + '/' + getfilterChainNoTruck();
    window.location.href = newUrl.replace('//','/');
  } else {
    window.location.href = el.attr('data-href');
  }

}
function clearCheckboxes(filterGroup, id, device){
  jQuery('[data-filter-group="' + filterGroup + '"][data-platform="' + device + '"] input:checked:not(#' + id + ')').removeAttr('checked');
}

function initProducts() {
  jQuery('.product-item .product-name').dotdotdot();
  jQuery('#load-more a').click(function(e) {
    e.preventDefault();
    if(!jQuery(this).is('[disabled="disabled"]')) loadMoreProducts();
    return false;
  })
}

function loadMoreProducts() {
  var $loadMore = jQuery('#load-more:not(.pagination-loading)');
  if($loadMore.length === 0) return;

  jQuery.ajax({
    type: 'GET',
    url: $loadMore.find('a').attr('href'),
    beforeSend: function() {
      $loadMore.addClass('pagination-loading').find('a').text('Loading...').attr('disabled', 'disabled');
    },
    success: function(data) {
      // remove loading indicator
      jQuery('#load-more.pagination-loading').remove();

      jQuery('.products-grid').append(jQuery(data).find('.products-grid').find('.product-item'));
      jQuery('.pagination-count').replaceWith(jQuery(data).find('.pagination-count'));
      jQuery(data).find('#load-more').insertAfter(jQuery('.pagination-count'));

      initProducts();
    },
    dataType: 'html'
  })
}

jQuery(function($){
  if(jQuery('#filters_container li').length <= 2){
    jQuery( "#filters_container").removeClass('with-filters');
  } else {
    jQuery( "#filters_container").addClass('with-filters');
  }

  jQuery( "#filter_list li:contains(truck)").remove();
  jQuery( "#modal_filters_list li:contains(truck)").remove();

  jQuery('.active_checkbox a').change(function(){
    window.location.href = jQuery(this).next('a').attr('href');
  });

  jQuery('.compatibility-modal-toggle').on('click', function (event) {
    countFilters();
    event.preventDefault();
    jQuery('#truck_filter_modal').toggleClass('is-visible');
  });

  jQuery('[data-filters-modal-toggle]').on('click', function (event) {
    countFilters();
    event.preventDefault();
    jQuery('#filters_modal').toggleClass('is-visible');
  });

  jQuery('#clear-filter-mobile').click(function(e){
    window.location.href= jQuery(this).attr('data-href');
  });

  jQuery('.tag_filter').on('change',function(event){
    event.preventDefault();

    currentCollection = jQuery('#collection_url').val();
    currentUrl = window.location.href.split(currentCollection);
    currentUrl = currentUrl[0] + currentCollection;

    appendFilter(currentUrl + getfilterChain());
  });

  jQuery('.clear-vehicle-filter, .clear-vehicle-filter-button').click(function() {
    Cookies.remove(VEHICLE_COOKIE);
  });

  if (jQuery('form.compatibility-selector, form.mobile-compatibility-selector').length > 0 && Cookies.get(VEHICLE_COOKIE)) {
    reloadWithVehicle(jQuery(jQuery('form.compatibility-selector')[0]).data('base-url'),
                      jQuery(jQuery('form.compatibility-selector')[0]).data('current-category'),
                      Cookies.get(VEHICLE_COOKIE));
  }

  jQuery('form.compatibility-selector, form.mobile-compatibility-selector').each(function() {
    var $form =   jQuery(this),
        $make =   $form.find('[name="make"]'),
        $model =  $form.find('[name="model"]'),
        baseUrl = $form.data('base-url'),
        categoryTag = $form.data('current-category'),
        refreshSubmitDisabled = function() {
          $form.find('[type="submit"]').prop('disabled', function() {
            return $make.val().length === 0 || $model.val().length === 0;
          });
        };

    $make.on('change', function(){
      var models = jQuery(this).find('option:selected').data('models');
      var modelsHandles = jQuery(this).find('option:selected').data('models-handles');

      $model.empty().append('<option value="">' + $model.data('default-option') + '</option>');

      if(models) {
        for(var i = 0; i < models.length; i ++) {
          var model = models[i];
          var handle = modelsHandles[i]

          $model.append('<option value="' + model + '" data-handle="' + handle + '">' + model + '</option>');
        }
        $model.attr('disabled', false);
      } else {
        $model.attr('disabled', true);
      }

      refreshSubmitDisabled();
    });

    $model.on('change', refreshSubmitDisabled);

    $form.submit(function() {
      if($make.val().length === 0 || $model.val().length === 0) return false;

      var makeHandle = $make.find('option:selected').data('handle');
      var modelHandle = $model.find('option:selected').data('handle');
      var tag = ['compatibility', makeHandle, modelHandle].join('-');

      Cookies.set(VEHICLE_COOKIE, tag);
      reloadWithVehicle(baseUrl, categoryTag, tag);

      return false;
    });

    $make.trigger('change');
  });

  jQuery('form.home-compatibility-selector').each(function() {
    var $form =   jQuery(this),
        $make =   $form.find('[name="make"]'),
        $model =  $form.find('[name="model"]'),
        baseUrl = $form.data('base-url'),
        refreshSubmitDisabled = function() {
          var isComplete = $make.val().length !== 0 && $model.val().length !== 0;

          if (isComplete) {
            var makeHandle = $make.find('option:selected').data('handle'),
                modelHandle = $model.find('option:selected').data('handle'),
                tag = ['compatibility', makeHandle, modelHandle].join('-');

            $form.attr('action', baseUrl + '/' + tag);
          } else {
            $form.attr('action', '');
          }

          $form.find('[type="submit"]').prop('disabled', !isComplete);
        };

    $make.on('change', function(){
      var models = jQuery(this).find('option:selected').data('models');
      var modelsHandles = jQuery(this).find('option:selected').data('models-handles');

      $model.empty().append('<option value="">' + $model.data('default-option') + '</option>');

      if(models) {
        for(var i = 0; i < models.length; i ++) {
          var model = models[i];
          var handle = modelsHandles[i]

          $model.append('<option value="' + model + '" data-handle="' + handle + '">' + model + '</option>');
        }
        $model.attr('disabled', false);
      } else {
        $model.attr('disabled', true);
      }

      refreshSubmitDisabled();
    });

    $model.on('change', refreshSubmitDisabled);

    $make.trigger('change');
  });

  jQuery('nav.nav-bar .site-nav--search button').on('click touchstart', function() {
    setTimeout(function() {
      jQuery('#NavDrawer [type="search"]').focus().select();
    }, 100);
  });

  jQuery( "#update_filters" ).on('click', function() {
    var vehicle = jQuery('[data-current-vehicle-tag]').data('current-vehicle-tag') ? jQuery('[data-current-vehicle-tag]').data('current-vehicle-tag').replace(':','-').toLowerCase() : null;
    var checked_filters = vehicle ? vehicle : '';

    jQuery('#modal_filters_list input:checked').each(function() {
      var path = jQuery(this).attr('id');
      checked_filters = checked_filters.length > 0 ? checked_filters + '+' + path : path;
    });

    currentCollection = jQuery('#collection_url').val();
    currentUrl = window.location.href.split(currentCollection);
    currentUrl = currentUrl[0] + currentCollection;

    appendFilter(currentUrl + '/' + checked_filters);
  });

  jQuery('.clear-vehicle-filter').on('click',function(e){
    e.preventDefault();
    resetVehicleFilter(jQuery(this));
  });

  countFilters();

  jQuery('#reset_filters_link').on('click',function(e) {
    e.preventDefault();

    window.location.href = jQuery(this).attr('data-href');

    return false;
  });
  jQuery('#modal_filters_list li').on('change',function(){
    countFilters();
  });
  var collectionUrl = jQuery('#collection_url').val();

  // Init photos plugins
  if(jQuery('#product-photos').length > 0) {
    jQuery('.owl-carousel').each(function() {
      var openPhotoSwipe = function() {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            $owlItems = jQuery(this).find('.owl-item:not(.cloned)'),
            items = [],
            startAtIndex = 0;

        for(var i = 0; i < $owlItems.length; i ++) {
          var $owlItem = jQuery($owlItems[i]),
              $photoLink = $owlItem.find('a');

          items.push({
            src: $photoLink.attr('href'),
            w: parseInt($photoLink.attr('data-width'), 10),
            h: parseInt($photoLink.attr('data-height'), 10)
          });

          if($owlItem.hasClass('active')) {
            startAtIndex = i;
          }
        }

        if(startAtIndex === 0 && jQuery(this).find('.owl-item.active')) {
          var activeSrc = jQuery(this).find('.owl-item.active a').attr('href');

          for(var k = 0; k < items.length; k ++) {
            if(items[k].src === activeSrc) {
              startAtIndex = k;
              break;
            }
          }
        }

        var options = {
            index: startAtIndex,
            history: false,
            focus: false,
            showAnimationDuration: 0,
            hideAnimationDuration: 0
        };
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
      }.bind(this);

      jQuery(this).on('click', '.owl-item a', function(e) {
        e.preventDefault();

        openPhotoSwipe();

        return false;
      });
    });
    var photosCount = jQuery(".owl-carousel img").length;
    jQuery(".owl-carousel").owlCarousel({
      items: 1,
      lazyLoad: true,
      loop: photosCount > 1,
      dots: true,
      touchDrag: true,
      thumbs: photosCount > 1,
      thumbsPrerendered: true,
      autoHeight: true
    });
  }

  initProducts();

  // blog products parser
  jQuery('[itemprop="articleBody"], body.template-page .main-content').each(function() {
    var $articleBody = jQuery(this),
        productCardTemplate = document.getElementById('template_blog_product_card').innerHTML,
        storeUrl = jQuery('body').data('shop-url') || 'https://miamistar.com',
        productUrl = storeUrl + '/products/',
        productCompile = Hogan.compile(productCardTemplate, { delimiters: '[[ ]]' });

    $articleBody.find('p, a').each(function() {
      var $elem = jQuery(this),
          text = $elem.html();

      if(text.indexOf(productUrl) < 0) return;

      var link = text.split('?')[0];

      jQuery.getJSON(link + '.js', function(product) {
        var toRender = {
          product: product,
          variant: product.variants[0],
          price: function() {
            if(!this.product.price || this.product.price === 0) return null;

            return Shopify.formatMoney(this.product.price, '${{amount}}');
          },
          compare_at_price: function() {
            if(!this.product.compare_at_price || this.product.compare_at_price === 0) return null;
            if(this.product.compare_at_price === this.product.price) return null;

            return Shopify.formatMoney(this.product.compare_at_price, '${{amount}}');
          },
          isRetailOnly: function() {
            return (this.product.tags || []).includes('attribute::available-sale::instore-only') || this.product.type === 'Retail Only';
          },
          isOnSale: function() {
            return this.product.compare_at_price > this.product.price;
          },
          isAvailable: function() {
            return this.product.available;
          }
         };
        jQuery(productCompile.render(toRender)).insertBefore($elem);
        $elem.addClass('product-link-parsed');
      });
    });
  });

  // scroll up plugin
  jQuery.scrollUp();

  jQuery('.product-tabs__link').click(function() {
    jQuery(this).parent('.tab').toggleClass('open');
  });

  // overlay
  if(jQuery('[data-overlay]').length === 0) {
    jQuery('body').append('<div class="overlay" data-overlay></div>');
  }
  jQuery('[data-overlay]').on('click', function() {
    jQuery('[data-overlay]').fadeOut(300);
  });
  var showOverlay = function() {
    jQuery('[data-overlay]').fadeIn(300);
  }, hideOverlay = function() {
    jQuery('[data-overlay]').fadeOut(300);
  }

  // scroll utils
  var scrollLock = function() {
    $('html, body').addClass('no-scroll');
  }, scrollUnlock = function() {
    $('html, body').removeClass('no-scroll');
  }

  var showFeedbackModal = function(title, content) {
    jQuery('.pickup-modal .pickup-modal__heading').text(title);
    jQuery('.pickup-modal .pickup-modal__content').empty().append(content);
    showOverlay();
    scrollLock();
    jQuery('.pickup-modal').addClass('is-active');
    return false;
  };
  jQuery('#CallToOrder').click(function(e) {
    e.preventDefault();
    return showFeedbackModal('For more Info', 'Please call to verify availability <a href="tel:+13058888669">1 (305) 888-8669</a><br><br><button type="submit" name="add" id="AddToCartClick" onClick="jQuery(\'#AddToCartForm\').submit();" class="btn btn-success btn--full add-to-cart-btn"><span id="AddToCartText">ADD TO CART</span></button>');
  });
  jQuery('#NotAvailableForSale').click(function(e) {
    e.preventDefault();
    return showFeedbackModal('Please call us!', 'The product you\'ve selected is not available for shipment.  Please call our Sales & Support team at <a href="tel:+13058888669">1 (305) 888-8669</a>.');
  });
  jQuery('#AddToCartForm').submit(function(e) {
    var isShipable = jQuery('#is-shipable').val();
    if (!isShipable){
      e.preventDefault();
      return showFeedbackModal('Please call us!', 'The product you\'ve selected is not available for shipment.  Please call our Sales & Support team at <a href="tel:+13058888669">1 (305) 888-8669</a>.');
    } else if (jQuery(this).find('#pickupInStore').is(':checked') && (this.product.tags || []).includes('attribute::available-sale::instore-only')) {

      e.preventDefault();
      return showFeedbackModal('For more info', 'Please call our Sales & Support team at <a href="tel:+13058888669">1 (305) 888-8669</a>.');
    }
  });
  jQuery('.product-cart-not-shippable .add-to-cart-btn').click(function(e) {
    e.preventDefault();

    showFeedbackModal('For more info', 'Please call our Sales & Support team at <a href="tel:+13058888669">1 (305) 888-8669</a>.');

    return false;
  });
  jQuery('[data-overlay], .pickup-modal [data-modal-close]').click(function() {
    jQuery('.pickup-modal').removeClass('is-active');
    scrollUnlock();
    hideOverlay();
  });

  if (window.miamistarInstagram) {
    jQuery('.instagram-feed').each(function() {
      var $elem = $(this),
          $loadMoreButton = $elem.parent().find('.instagram-feed-load-more');

      var feed = new Instafeed({
        get: 'user',
        userId: window.miamistarInstagram.userId,
        accessToken: window.miamistarInstagram.accessToken,
        target: $elem[0],
        limit: 4,
        resolution: 'low_resolution',
        template: '<a class="instagram-feed__item" href="{{link}}" target="_blank" style="background-image: url({{image}})"></a>',
        after: function() {
          $loadMoreButton.toggle(this.hasNext());
        },
      });
      $loadMoreButton.click(function() {
        feed.next();
      });
      feed.run();
    });
  }

  $('[data-auth-modal]').each(function() {
    var modalId = $(this).data('auth-modal'),
        $modal = $('#' + modalId),
        $backdrop = $('.auth-modal__backdrop');

    $(this).click(function(e) {
      e.preventDefault();

      var $activeModal = $('.auth-modal.is--shown');
      if($activeModal.length !== 0) {
        if ($activeModal.attr('id') === modalId) return;

        $activeModal.removeClass('is--shown');
      }

      $modal.addClass('is--shown');
      $backdrop.addClass('is--shown');
      $('body').addClass('is--auth-modal-open');

      return false;
    });
  });
  $('[data-close-auth-modal]').click(function(e) {
    if (e.target.getAttribute('data-close-auth-modal') === null) return;

    e.preventDefault();

    $('.auth-modal.is--shown, .auth-modal__backdrop.is--shown').removeClass('is--shown');
    $('body').removeClass('is--auth-modal-open');

    return false;
  });
});

jQuery('#searchForm').submit(function() {
  if (jQuery.trim(jQuery("#searchInput").val()) === "") {
      return false;
  }
});
